import React, { useState, useEffect } from 'react';
import { getOriginalDescription } from '../../../services/product/productService';
import translateService from '../../../common/translateService';

const ProductDescription = (props) => {
    const [descriptionInLanguage, setDescriptionInLanguage] = useState('');
    const [descriptionInOriginalLanguage, setDescriptionInOriginalLanguage] =
        useState('');
    const [descriptionToShow, setDescriptionToShow] = useState({
        description: '',
        state: 'translated',
        message: 'seeOriginal',
    });
    const [haveFetchedOriginal, setHaveFetchedOriginal] = useState(false);

    const getDescription = async () => {
        return await getOriginalDescription(props.descriptionOriginalUrl);
    };

    useEffect(() => {
        setDescriptionInLanguage(props.description);
        setDescriptionToShow((prevState) => ({
            ...prevState,
            description: props.description,
        }));
    }, [props.description]);

    const updateTranslation = async () => {
        if (!haveFetchedOriginal) {
            const description = await getDescription();
            setDescriptionInOriginalLanguage(description.description);
            setDescriptionToShow({
                description: description.description,
                state: 'original',
                message: 'backToTranslation',
            });
            setHaveFetchedOriginal(true);
            return;
        }

        switch (descriptionToShow.state) {
            case 'translated':
                setDescriptionToShow({
                    description: descriptionInOriginalLanguage,
                    state: 'original',
                    message: 'backToTranslation',
                });
                break;
            case 'original':
                setDescriptionToShow({
                    description: descriptionInLanguage,
                    state: 'translated',
                    message: 'seeOriginal',
                });
                break;
            default:
                break;
        }
    };

    return (
        <>
            {props.descriptionAutomated && (
                <div className='prd-tab-description-automaticTranslation'>
                    <p>
                        <span className='prd-alert'>!</span>{' '}
                        {translateService.get(
                            `productDetail.automatedTranslation.${descriptionToShow.state}`
                        )}{' '}
                        <span className='prd-link' onClick={updateTranslation}>
                            {translateService.get(
                                `productDetail.${descriptionToShow.message}`
                            )}
                        </span>
                    </p>
                </div>
            )}
            <div
                itemProp='description'
                dangerouslySetInnerHTML={{
                    __html: props.descriptionAutomated
                        ? descriptionToShow.description
                        : props.description,
                }}
            />
        </>
    );
};

export default ProductDescription;
